export default {
  create: 'create',
  get: 'get',
  update: 'update',
  delete: 'delete',
  trigger: 'trigger',
  download: 'download'
}
